import { api } from "@/lib/api";
import { Tour, TourDtoSchema, tourFromDto, tourToDto } from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getTourQueryOptions, getToursQueryOptions } from "./get.hooks";

export function useUpdateTour(opts?: {
  onSuccess?: (tour: Tour) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (tour: Tour) => {
      const dto = tourToDto(tour);
      const result = await api.put("/api/tours", dto, TourDtoSchema);
      return tourFromDto(result);
    },
    onSuccess: (tour) => {
      queryClient.setQueryData(getToursQueryOptions.queryKey, (old) =>
        old?.map((t) => (t.id !== tour.id ? t : tour)),
      );
      queryClient.setQueryData(
        getTourQueryOptions(tour.id).queryKey,
        () => tour,
      );
      toast({
        title: "toast.tourUpdated",
        variant: "success",
      });
      opts?.onSuccess?.(tour);
    },
    onError: () => {
      toast({
        title: "toast.updateTourError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
